import { PointIcons } from 'models/custom-layer'

export const IconUtils = {
  getIconFromName: (name: PointIcons) => {
    switch (name) {
      case PointIcons.Circle:
        return 'checkbox-blank-circle-fill'
      case PointIcons.Diamond:
        return 'vip-diamond-fill'
      case PointIcons.Factory:
        return 'building-3-fill'
      case PointIcons.Flag:
        return 'flag-2-fill'
      case PointIcons.Home:
        return 'home-2-fill'
      case PointIcons.Pin:
        return 'map-pin-3-fill'
      case PointIcons.Square:
        return 'checkbox-blank-fill'
      default:
        return `${name}-fill`
    }
  },
}
